import { useState, useCallback, useEffect } from "react";

let globalSidebarState = {
  adminSidebarOpen: false,
  messagesSidebarOpen: false,
  listeners: [],
};

const addListener = (callback) => {
  globalSidebarState.listeners.push(callback);
  return () => {
    globalSidebarState.listeners = globalSidebarState.listeners.filter(
      (listener) => listener !== callback
    );
  };
};

const notifyListeners = () => {
  globalSidebarState.listeners.forEach((listener) => listener(globalSidebarState));
};

export const useSidebarManager = () => {
  const [state, setState] = useState(globalSidebarState);

  const forceUpdate = useCallback((newState) => {
    setState({ ...newState });
  }, []);

  useEffect(() => {
    const removeListener = addListener(forceUpdate);

    const handleResize = () => {
      if (window.innerWidth >= 992) {
        globalSidebarState.adminSidebarOpen = false;
        globalSidebarState.messagesSidebarOpen = false;
        notifyListeners();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      removeListener();
      window.removeEventListener("resize", handleResize);
    };
  }, [forceUpdate]);

  const setAdminSidebarOpen = useCallback((open) => {
    const newOpen = typeof open === "function" ? open(globalSidebarState.adminSidebarOpen) : open;

    globalSidebarState.adminSidebarOpen = newOpen;

    if (newOpen && window.innerWidth < 992) {
      globalSidebarState.messagesSidebarOpen = false;
    }

    notifyListeners();
  }, []);

  const setMessagesSidebarOpen = useCallback((open) => {
    const newOpen =
      typeof open === "function" ? open(globalSidebarState.messagesSidebarOpen) : open;

    globalSidebarState.messagesSidebarOpen = newOpen;

    if (newOpen && window.innerWidth < 992) {
      globalSidebarState.adminSidebarOpen = false;
    }

    notifyListeners();
  }, []);

  const closeBothSidebars = useCallback(() => {
    globalSidebarState.adminSidebarOpen = false;
    globalSidebarState.messagesSidebarOpen = false;
    notifyListeners();
  }, []);

  return {
    adminSidebarOpen: state.adminSidebarOpen,
    messagesSidebarOpen: state.messagesSidebarOpen,
    setAdminSidebarOpen,
    setMessagesSidebarOpen,
    closeBothSidebars,
  };
};
